import { render } from "./DefaultFooter.vue?vue&type=template&id=25f437e0&scoped=true"
import script from "./DefaultFooter.vue?vue&type=script&lang=js"
export * from "./DefaultFooter.vue?vue&type=script&lang=js"

import "./DefaultFooter.vue?vue&type=style&index=0&id=25f437e0&lang=scss&scoped=true"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f437e0"]])

export default __exports__